import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const markMessageAsUnread = async (id: string): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation markMessageAsUnread($id: String!) {
        markMessageAsUnread(id: $id)
      }
    `),
    variables: {
      id,
    },
  });

  return response.data?.markMessageAsUnread ?? false;
};
